import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <div className="py-6 bg-white">
        <div className="container px-4 mx-auto text-center text-gray-600 sm:px-6 lg:px-8">
          <span>CO.ME.ST. S.r.l. è in VIA CRISTOFORO COLOMBO 5, 10070 Robassomero (TO), Italia — </span>
          <a href="tel:+390119241104" className="text-[#3b5998]">(+39) 011 9241104</a>
          <span> — </span>
          <a href="mailto:info@comestsrl.eu" className="text-[#3b5998]">info@comestsrl.eu</a>
        </div>
      </div>
      <footer className="py-4 text-white bg-[#4a4a4a]">
        <div className="container flex justify-between items-center px-4 mx-auto sm:px-6 lg:px-8">
          <p className="text-sm">
            Copyright {currentYear} CO.ME.ST. S.r.l. - Partita IVA IT02135640015
          </p>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="bg-[#3b5998] hover:bg-blue-800 text-white font-bold p-2 rounded"
          >
            ^
          </button>
        </div>
      </footer>
    </>
  );
};

export default Footer;